declare const process
const baseUrl = process.env.PUBLIC_URL

const SS_TEST_KEY = '__IS_SESSION_STORAGE_SUPPORTED__'
let isSessionStorageSupported = typeof sessionStorage === 'object'

if (global['sessionStorage']) {
  try {
    sessionStorage.setItem(SS_TEST_KEY, 'test')
    sessionStorage.removeItem(SS_TEST_KEY)
  } catch (e) {
    isSessionStorageSupported = false

    // If we get error that we exceeded storage's quota
    // but storage is still empty we are in private mode
    if (
      e.code === DOMException.QUOTA_EXCEEDED_ERR &&
      sessionStorage.length === 0
    ) {
      // Private mode
    } else {
      throw e
    }
  }
}

const SessionStorage = {
  getItem: key => {
    if (isSessionStorageSupported) {
      return sessionStorage.getItem(key)
    }
    return undefined
  },

  setItem: (key, value) => {
    if (isSessionStorageSupported) {
      sessionStorage.setItem(key, value)
    }
  },

  removeItem: key => {
    if (isSessionStorageSupported) {
      sessionStorage.removeItem(key)
    }
  }
}

export default SessionStorage
